// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"6350":"712e49b3065056bf","6491":"12d945b85f468241","7856":"89a61048111254b1"}[chunkId] + ".js";
};